import { AxiosResponse } from "axios";

export default function saveBlobFile(fileResponse: AxiosResponse, fileName: string): void {
    const url = globalThis.URL.createObjectURL(fileResponse.data);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    globalThis.URL.revokeObjectURL(url);
}